/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, Fragment } from "react";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { isStringNotEmpty } from "utils/empty-exists";

const EmbedComponentDisplay = () => {
    const ctx = useContext(ContentZoneContext);
    const { component } = ctx;
    const { html = [], isResponsive = "" } = component || {};
    const hasContent = isStringNotEmpty(html);
    const classes = isResponsive === "on" ? "simplicity-embed responsive" : "simplicity-embed";

    return (
        <Fragment>
            <div
                className={classes}
                dangerouslySetInnerHTML={{ __html: component.html }}
            />
            {!hasContent &&
                <EmptyContentMessage
                    hasContent={hasContent}
                    component={component}
                />
            }
        </Fragment>
    );
};


EmbedComponentDisplay.displayName = "EmbedComponentDisplay";
export { EmbedComponentDisplay };
